/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AccessService } from 'src/app/providers/access/access.service';
import { ApiService } from 'src/app/providers/apiService/api.service';
import { StorageService } from 'src/app/providers/storageService/storage.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-billing',
  templateUrl: './billing.page.html',
  styleUrls: ['./billing.page.scss'],
})
export class BillingPage implements OnInit {
  user: any;
  unreadCount: any;
  // eslint-disable-next-line @typescript-eslint/ban-types
  state$: Observable<object>;
  patientDetail: any;
  submissionData = [];
  hasSkelton: boolean;
  userData: any;
  doctorRole = 'physician';
  imgBaseUrl = environment.imgBaseUrl;

  constructor(
    private apiService: ApiService,
    public route: ActivatedRoute,
    public navCtrl: NavController,
    public storageService: StorageService,
    public router: Router,
    public accessService: AccessService,

  ) {
    this.route.queryParams.subscribe(params => {
      if (this.router.getCurrentNavigation().extras.state) {
        this.patientDetail = this.router.getCurrentNavigation().extras.state;
      }
    });
  }

  ngOnInit() {
    this.getnotificationCount();
    this.getBillingList();
    this.storageService.get('doctor_role').then(res => {
      this.doctorRole = res;
    });
  }

  ionViewDidEnter() {
    this.accessService.resetLogoutTimer();
  }

  getnotificationCount() {
    this.apiService
      .post('user/get-unread-notification-count', {})
      .subscribe(
        (res) => {
          if (res.error === false) {
            this.unreadCount = res.data.unread_notifications;
          }
        },
        (err) => { }
      );
  }

  getBillingList() {
    this.hasSkelton = true;
    const params = {
      submission_id: this.patientDetail.Data.id
    };
    this.apiService
      .post('data/all-billings', params)
      .subscribe(
        (res) => {
          this.hasSkelton = false;
          if (res.error === false) {
            this.submissionData = res.data.Billing;
            this.userData = res.data.Data;
            //console.log('billing list is ::', res);
          }
        },
        (err) => {
          this.hasSkelton = false;
        }
      );
  }

  onBillingScreen() {
    this.patientDetail.fromPatientList = true;
    this.patientDetail.newPatientCreated = true;
    const navigationExtras: NavigationExtras = {
      state: this.patientDetail
    };
    this.navCtrl.navigateForward('/' + this.doctorRole, navigationExtras);
  }

  formatItems(itemList, itemListAdditional) {
    const [list, additional] = [itemList || '[]', itemListAdditional || '[]'];
    if (itemList && itemListAdditional) {
      return list.replace('[', '').replace(']', '') + ',' + additional.replace('[', '').replace(']', '');
    } else {
      return list.replace('[', '').replace(']', '') + additional.replace('[', '').replace(']', '');
    }
  }
  formatItemsConsult(itemList) {
    const [list] = [itemList || '[]'];
    if (itemList) {
      return list.replace('[', '').replace(']', '');
    } else {
      return list.replace('[', '').replace(']', '');
    }
  }
}
